import { RSAA } from 'redux-api-middleware';
import TELEMETRY_API from '../../config/api';

export const VISIT_NOTES_REQUEST = 'VISIT_NOTES_REQUEST';
export const VISIT_NOTES_SUCCESS = 'VISIT_NOTES_SUCCESS';
export const VISIT_NOTES_FAILURE = 'VISIT_NOTES_FAILURE';

export const PROTOCOL_FLAGS_REQUEST = 'PROTOCOL_FLAGS_REQUEST';
export const PROTOCOL_FLAGS_SUCCESS = 'PROTOCOL_FLAGS_SUCCESS';
export const PROTOCOL_FLAGS_FAILURE = 'PROTOCOL_FLAGS_FAILURE';

export const CONTROLLED_SUBS_REQUEST = 'CONTROLLED_SUBS_REQUEST';
export const CONTROLLED_SUBS_SUCCESS = 'CONTROLLED_SUBS_SUCCESS';
export const CONTROLLED_SUBS_FAILURE = 'CONTROLLED_SUBS_FAILURE';

export const ALERTS_REQUEST = 'ALERTS_REQUEST';
export const ALERTS_SUCCESS = 'ALERTS_SUCCESS';
export const ALERTS_FAILURE = 'ALERTS_FAILURE';

export const REVIEW_REQUEST = 'REVIEW_REQUEST';
export const REVIEW_SUCCESS = 'REVIEW_SUCCESS';
export const REVIEW_FAILURE = 'REVIEW_FAILURE';

export const CPT_REVIEW_REQUEST = 'CPT_REVIEW_REQUEST';
export const CPT_REVIEW_SUCCESS = 'CPT_REVIEW_SUCCESS';
export const CPT_REVIEW_FAILURE = 'CPT_REVIEW_FAILURE';

export const FOLLOW_UP_REQUEST = 'FOLLOW_UP_REQUEST';
export const FOLLOW_UP_SUCCESS = 'FOLLOW_UP_SUCCESS';
export const FOLLOW_UP_FAILURE = 'FOLLOW_UP_FAILURE';

export const ALERT_LIMITS_REQUEST = 'ALERT_LIMITS_REQUEST';
export const ALERT_LIMITS_SUCCESS = 'ALERT_LIMITS_SUCCESS';
export const ALERT_LIMITS_FAILURE = 'ALERT_LIMITS_FAILURE';

export const ACTIONS_REQUEST = 'ACTIONS_REQUEST';
export const ACTIONS_SUCCESS = 'ACTIONS_SUCCESS';
export const ACTIONS_FAILURE = 'ACTIONS_FAILURE';

export const ADD_ACTION_REQUEST = 'ADD_ACTION_REQUEST';
export const ADD_ACTION_SUCCESS = 'ADD_ACTION_SUCCESS';
export const ADD_ACTION_FAILURE = 'ADD_ACTION_FAILURE';

export const ENCOUNTERS_REQUEST = 'ENCOUNTERS_REQUEST';
export const ENCOUNTERS_SUCCESS = 'ENCOUNTERS_SUCCESS';
export const ENCOUNTERS_FAILURE = 'ENCOUNTERS_FAILURE';

export const VISIT_NOTE_REQUEST = 'VISIT_NOTE_REQUEST';
export const VISIT_NOTE_SUCCESS = 'VISIT_NOTE_SUCCESS';
export const VISIT_NOTE_FAILURE = 'VISIT_NOTE_FAILURE';

export const BULLETS_REQUEST = 'BULLETS_REQUEST';
export const BULLETS_SUCCESS = 'BULLETS_SUCCESS';
export const BULLETS_FAILURE = 'BULLETS_FAILURE';

export const ICD_LOOKUP_REQUEST = 'ICD_LOOKUP_REQUEST';
export const ICD_LOOKUP_SUCCESS = 'ICD_LOOKUP_SUCCESS';
export const ICD_LOOKUP_FAILURE = 'ICD_LOOKUP_FAILURE';

export const MEDICATIONS_REQUEST = 'MEDICATIONS_REQUEST';
export const MEDICATIONS_SUCCESS = 'MEDICATIONS_SUCCESS';
export const MEDICATIONS_FAILURE = 'MEDICATIONS_FAILURE';

export const AUDIT_LOG_REQUEST = 'AUDIT_LOG_REQUEST';
export const AUDIT_LOG_SUCCESS = 'AUDIT_LOG_SUCCESS';
export const AUDIT_LOG_FAILURE = 'AUDIT_LOG_FAILURE';



export const SET_VIEW = 'SET_VIEW';

export function requestVisitNotes(params = {}) {
  const query = $.param(params, true);
  return {
    [RSAA]: {
      endpoint: `${TELEMETRY_API}organization/clinic/visit-notes?${query}`,
      method: 'GET',
      types: [
        'VISIT_NOTES_REQUEST',
        'VISIT_NOTES_SUCCESS',
        'VISIT_NOTES_FAILURE',
      ],
    },
  };
}

export function requestProtocolFlags(params = {}) {
  const query = $.param(params, true);
  return {
    [RSAA]: {
      endpoint: `${TELEMETRY_API}organization/clinic/visit-notes/protocol-flags?${query}`,
      method: 'GET',
      types: [
        'PROTOCOL_FLAGS_REQUEST',
        'PROTOCOL_FLAGS_SUCCESS',
        'PROTOCOL_FLAGS_FAILURE',
      ],
    },
  };
}

export function requestControlledSubs(params = {}) {
  const query = $.param(params, true);
  return {
    [RSAA]: {
      endpoint: `${TELEMETRY_API}organization/clinic/controlled-subs?${query}`,
      method: 'GET',
      types: ['CONTROLLED_SUBS_REQUEST', 'CONTROLLED_SUBS_SUCCESS', 'CONTROLLED_SUBS_FAILURE'],
    },
  };
}

export function requestAlerts(params = {}) {
  const query = $.param(params, true);
  return {
    [RSAA]: {
      endpoint: `${TELEMETRY_API}organization/clinic/visit-notes/alert?${query}`,
      method: 'GET',
      types: ['ALERTS_REQUEST', 'ALERTS_SUCCESS', 'ALERTS_FAILURE'],
    },
  };
}

export function requestReview(params = {}) {
  const query = $.param(params, true);
  return {
    [RSAA]: {
      endpoint: `${TELEMETRY_API}organization/clinic/visit-notes/review?${query}`,
      method: 'GET',
      types: ['REVIEW_REQUEST', 'REVIEW_SUCCESS', 'REVIEW_FAILURE'],
    },
  };
}

export function requestCptReview(params = {}) {
  const query = $.param(params, true);
  return {
    [RSAA]: {
      endpoint: `${TELEMETRY_API}organization/clinic/visit-notes/cpt-review?${query}`,
      method: 'GET',
      types: ['CPT_REVIEW_REQUEST', 'CPT_REVIEW_SUCCESS', 'CPT_REVIEW_FAILURE'],
    },
  };
}

export function requestFollowUp(params = {}) {
  const query = $.param(params, true);
  return {
    [RSAA]: {
      endpoint: `${TELEMETRY_API}organization/clinic/visit-notes/follow-up?${query}`,
      method: 'GET',
      types: ['FOLLOW_UP_REQUEST', 'FOLLOW_UP_SUCCESS', 'FOLLOW_UP_FAILURE'],
    },
  };
}

export function requestAlertLimits() {
  return {
    [RSAA]: {
      endpoint: `${TELEMETRY_API}catalog/lookups/alert-limits`,
      method: 'GET',
      types: [
        'ALERT_LIMITS_REQUEST',
        'ALERT_LIMITS_SUCCESS',
        'ALERT_LIMITS_FAILURE',
      ],
    },
  };
}

export function requestActions(visitNoteID, params = {}) {
  const query = $.param({ ...params, order: 'asc createdAt' });
  return {
    [RSAA]: {
      endpoint: `${TELEMETRY_API}organization/clinic/visit-notes/${visitNoteID}/actions?${query}`,
      method: 'GET',
      types: [
        { type: 'ACTIONS_REQUEST', meta: { visitNoteID } },
        { type: 'ACTIONS_SUCCESS', meta: { visitNoteID } },
        'ACTIONS_FAILURE',
      ],
    },
  };
}

export function addAction(visitNoteID, data, params = {}) {
  const query = $.param(params);
  return {
    [RSAA]: {
      endpoint: `${TELEMETRY_API}organization/clinic/visit-notes/${visitNoteID}/actions?${query}`,
      method: 'POST',
      body: JSON.stringify(data),
      types: ['ADD_ACTION_REQUEST', 'ADD_ACTION_SUCCESS', 'ADD_ACTION_FAILURE'],
    },
  };
}

export function requestEncounters(patientID, visitNoteID, params = {}) {
  const query = $.param({ ...params, exclude: visitNoteID });
  return {
    [RSAA]: {
      endpoint: `${TELEMETRY_API}organization/clinic/patient/${patientID}/encounters?${query}`,
      method: 'GET',
      types: [
        { type: 'ENCOUNTERS_REQUEST', meta: { visitNoteID } },
        { type: 'ENCOUNTERS_SUCCESS', meta: { visitNoteID } },
        'ENCOUNTERS_FAILURE',
      ],
    },
  };
}

export function setView(view) {
  return dispatch => {
    return dispatch({
      type: SET_VIEW,
      view,
    });
  };
}


export function requestVisitNote(visitNoteID, params = {}) {
  const query = $.param(params);
  return {
    [RSAA]: {
      endpoint: `${TELEMETRY_API}organization/clinic/visit-notes/${visitNoteID}?${query}`,
      method: 'GET',
      types: [
        { type: 'VISIT_NOTE_REQUEST', meta: { visitNoteID } },
        { type: 'VISIT_NOTE_SUCCESS', meta: { visitNoteID } },
        'VISIT_NOTE_FAILURE',
      ],
    },
  };
}

export function requestBullets(visitNoteID, params = {}) {
  const query = $.param(params);
  return {
    [RSAA]: {
      endpoint: `${TELEMETRY_API}organization/clinic/visit-notes/${visitNoteID}/bullets?${query}`,
      method: 'GET',
      types: [
        { type: 'BULLETS_REQUEST', meta: { visitNoteID } },
        { type: 'BULLETS_SUCCESS', meta: { visitNoteID } },
        'BULLETS_FAILURE',
      ],
    },
  };
}


export function requestICDLookup(tenantId) {
  return {
    [RSAA]: {
      endpoint: `${TELEMETRY_API}organization/lookups/icd/all?tenantId=${tenantId}`,
      method: 'GET',
      types: [
        { type: 'ICD_LOOKUP_REQUEST', meta: { tenantId } },
        { type: 'ICD_LOOKUP_SUCCESS', meta: { tenantId } },
        'ICD_LOOKUP_FAILURE',
      ],
    },
  };
}

export function requestMedications(visitNoteID, patientID, serviceDate, tenantId) {
  return {
    [RSAA]: {
      endpoint: `${TELEMETRY_API}organization/patients/${patientID}/medication-orders?tenantId=${tenantId}&createdAt=${serviceDate}`,
      method: 'GET',
      types: [
        { type: 'MEDICATIONS_REQUEST', meta: { visitNoteID } },
        { type: 'MEDICATIONS_SUCCESS', meta: { visitNoteID } },
        'MEDICATIONS_FAILURE',
      ],
    },
  };
}

export function requestAuditLog(params = {}) {
  const query = $.param(params);
  return {
    [RSAA]: {
      endpoint: `${TELEMETRY_API}organization/clinic/visit-notes/audit/year?${query}`,
      method: 'GET',
      types: [
        'AUDIT_LOG_REQUEST',
        'AUDIT_LOG_SUCCESS',
        'AUDIT_LOG_FAILURE',
      ],
    },
  };
}



// WEBPACK FOOTER //
// ./src/store/visit-notes/VisitNotesActions.js